module.exports = __webpack_public_path__ + "img/header.23ff5a8.jpg";